import { render, staticRenderFns } from "./AdminBillingDetail.vue?vue&type=template&id=c32ba9c4&scoped=true"
import script from "./AdminBillingDetail.vue?vue&type=script&lang=ts"
export * from "./AdminBillingDetail.vue?vue&type=script&lang=ts"
import style0 from "./AdminBillingDetail.vue?vue&type=style&index=0&id=c32ba9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32ba9c4",
  null
  
)

export default component.exports